import React, { useEffect } from 'react';
import { compose } from 'redux';
import { GLOBALS } from 'services/globals';
import PageLoadingSpinner from 'components/layouts/Navigation/PageLoadingSpinner';
import {
  configError,
  receivedConfig,
  requestedConfig
} from 'state/config/ConfigActions';
import Store from 'state/Store';
import { connect } from 'react-redux';
import { getConfig, isConfigLoading } from 'state/config/ConfigSelectors';
import { withOtelContext } from '@trp-ta-nitro/otel-react';
import { CONFIG_INITIAL_STATE } from 'state/config/ConfigReducer';

export const ConfigContext = React.createContext(CONFIG_INITIAL_STATE);

const haveConfig = (config) => config && config.apiKey && config.version;

const ConfigProvider = ({ children, config }) => {
  useEffect(() => {
    if (!haveConfig(config)) {
      loadConfig();
    }
  }, []);

  const loadConfig = () => {
    Store.dispatch(requestedConfig());
    try {
      const response = fetch(`${GLOBALS.AAM_UI_TRP_APP_CONTEXT}/config.json`);
      response
        .then((loadedConfig) => {
          return loadedConfig.json();
        })
        .then((configJson) => {
          Store.dispatch(receivedConfig(configJson));
          if (window) {
            window.config = configJson;
          }
        });
    } catch (e) {
      Store.dispatch(configError(e));
    }
  };

  return haveConfig(config) ? (
    <ConfigContext.Provider value={{ config }}>
      {children}
    </ConfigContext.Provider>
  ) : (
    <PageLoadingSpinner name="Account Settings..." />
  );
};

const mapStateToProps = (state) => ({
  config: getConfig(state),
  configLoading: isConfigLoading(state)
});
export default compose(
  connect(mapStateToProps),
  withOtelContext
)(ConfigProvider);
